var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Wrapper',[_c('div',{staticClass:"desc"},[_vm._v(" 1925安心專線GO GO GO，對照位置點擊可愛的藍寶和金妮，連續正確點擊愈高分唷！ ")]),_c('div',{staticClass:"button",on:{"click":function($event){return _vm.$emit('ready')}}},[_vm._v("Ready")])])}
var staticRenderFns = []

export { render, staticRenderFns }